import { AlarmCheckIcon } from './AlarmCheckIcon';

/**
 * author: Google
 * id 6DCCA48F-E413-4C45-BFE5-8E3C8BE61A4E
 * name alarm-check
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alarm-check.svg
 * tags
 * - Date / Time 
 */
export const AlarmSuccessIcon = AlarmCheckIcon;
export default AlarmSuccessIcon